// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iW7k6","input":"styles_input__t9n-a"};